import type { BaseComponentProps, WithChildren } from "@neru/types";
import { forwardRef, type Ref } from "react";

interface RowProps extends BaseComponentProps, WithChildren {
  style?: object;
}

export const RowComponent = (
  { children, className = "", "data-testid": testId, ...props }: RowProps,
  ref: Ref<HTMLDivElement>,
) => (
  <div
    className={`
      flex flex-row
      ${className}
    `}
    data-testid={testId}
    {...props}
    ref={ref}
  >
    {children}
  </div>
);

export const Row = forwardRef(RowComponent);
